import { Layout, Typography, Button, Space } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@context/ThemeContext';
import { useAppSelector } from '@store/helpers';
import { AppUserMenuDropdown } from '@components/ui/AppUserMenuDropdown/AppUserMenuDropdown';
import { resolveAdminPageTitle } from '@router/adminNavigation';
import styles from './Header.module.css';

type Props = {
  onMenuClick: () => void;
  collapsed?: boolean;
  isMobile?: boolean;
};

const { Header: AntHeader } = Layout;
const { Title } = Typography;

const Header = ({ onMenuClick, collapsed, isMobile = false }: Props) => {
  const admin = useAppSelector(state => state.adminAuth.admin);
  const { colors } = useTheme();
  const location = useLocation();
  const pageTitle = resolveAdminPageTitle(location.pathname);

  return (
    <AntHeader
      className={styles.header}
      style={{
        background: colors.bg_600,
        padding: isMobile ? '0 12px' : '0 24px',
      }}
    >
      <Space size={isMobile ? 8 : 12}>
        <Button
          type="text"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={onMenuClick}
          styles={{ icon: { color: colors.text_500 } }}
          aria-label="Toggle sidebar"
          className={styles.menuButton}
        />
        <Title level={4} className={styles.title} style={{ color: colors.text_500 }}>
          {pageTitle}
        </Title>
      </Space>

      <AppUserMenuDropdown email={admin?.email} role={admin?.role} isMobile={isMobile} />
    </AntHeader>
  );
};

export default Header;
